/**
 * Generated by orval 🍺
 * Do not edit manually.
 * qcs control-plane
 * OpenAPI spec version: 0.1.0
 */

/**
 * The order a probe walk visits the probe points in.
 */
export type ProbeTraversal = typeof ProbeTraversal[keyof typeof ProbeTraversal];


export const ProbeTraversal = {
  rank_major: 'rank_major',
  city_major: 'city_major',
} as const;
